import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, AuthUser, AuthSession } from './types';

const initialState: AuthState = {
  user: null,
  session: null,
  role: '',
  permissions: []
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(
      state,
      action: PayloadAction<{ user: AuthUser; session: AuthSession; role?: string; permissions?: string[] }>
    ) {
      state.user = action.payload.user;
      state.session = action.payload.session;
      state.role = action.payload.role ?? '';
      state.permissions = action.payload.permissions ?? [];
    },
    refreshSession(state, action: PayloadAction<AuthSession | null>) {
      state.session = action.payload;
    },
    updateProfile(state, action: PayloadAction<Partial<AuthUser>>) {
      if (state.user) state.user = { ...state.user, ...action.payload };
    },
    logout(state, _action: PayloadAction<string | undefined>) {
      state.user = null;
      state.session = null;
      state.role = '';
      state.permissions = [];
    }
  }
});

export const { login, refreshSession, updateProfile, logout } = authSlice.actions;
export default authSlice.reducer;
